<template>
  <transition name="vue-toast-opacity">
    <div
      class="md-snackbar-container"
      :class="config.data.message.style"
      :style="style"
      @mouseover="_stopTimer"
      @mouseleave="_startTimer"
    >
      <div class="md-snackbar-content">
        <button
          id="snackBtnClose"
          class="close-button btn-transparent close-snack-container-btn"
          @click="remove"
        >
          <i
            aria-hidden="true"
            class="md-icon md-theme-default material-icons"
          >clear</i>
        </button>
        <div class="content-container">
          <span
            v-if="config.data.message.title"
            class="snack-title"
          >{{ config.data.message.title }}</span>
          <span class="snack-content">
            <template v-if="config.data.message.style === 'success'">
              <img
                src="/static/images/success-feedback-white.svg"
                width="33"
                height="33"
                alt="feedback-sucesso"
              >
            </template>
            {{ config.data.message.message }}
          </span>
        </div>
        <button
          v-if="config.data.message.action"
          type="button"
          class="md-button btn-reload md-theme-default"
          @click="fire(config.data.message.action.handler)"
        >
          {{
            config.data.message.action.title }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
const defaultOptions = {
  timeLife: 5000,
  closeBtn: false
}
export default {
  props: ['config'],
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    style () {
      return `transform: translateY(${this.config.data.options.directionOfJumping}${this.config.data.position * 100}%)`
    },
    fullOptions () {
      return defaultOptions
    }
  },
  mounted () {
    setTimeout(() => {
      this.isShow = true
    }, 50)
    if (!this.fullOptions.closeBtn) {
      this._startLazyAutoDestroy()
    }
  },
  methods: {
    // Public
    remove () {
      this._clearTimer()
      this.config.onDestroy()
    },
    // Private
    _startLazyAutoDestroy () {
      this._clearTimer()
      this.timerDestroy = setTimeout(() => {
        this.remove()
      }, this.fullOptions.timeLife)
    },
    _clearTimer () {
      if (this.timerDestroy) {
        clearTimeout(this.timerDestroy)
      }
    },
    _startTimer () {
      if (!this.fullOptions.closeBtn) {
        this._startLazyAutoDestroy()
      }
    },
    _stopTimer () {
      if (!this.config.data.options.closeBtn) {
        this._clearTimer()
      }
    },
    fire (handler) {
      handler()
    }
  }
}
</script>
<style lang="scss">
  .md-snackbar-container {
    &.success {
      background-color: #55CD9E;
      .md-snackbar-content {
        .close-button {
          position: absolute;
          top: 7px;
          right: 7px;
          i {
            color: #fff;
          }
        }
      }
    }
    &.error {
      background-color: #BC293A;
      .md-snackbar-content {
        .close-button {
          position: absolute;
          top: 7px;
          right: 7px;
          i {
            color: #fff;
          }
        }
      }
    }
    .md-snackbar-content {
      .content-container {
        display: flex;
        flex-direction: column;
        img {
          margin-right: 8px;
        }
        .snack-content {
          font-weight: 500;
        }
      }
    }
  }
  .vue-toast_container {
    position: absolute;
    padding-bottom: 10px;
    transform: translateY(0);
    transition: transform .2s ease-out;
    backface-visibility: hidden;

    &._default .vue-toast_message {
      background-color: rgba(#000, .9);
    }
    &._info .vue-toast_message {
      background-color: rgba(#31708f, .9);
    }
    &._success .vue-toast_message {
      background-color:  rgba(#3c763d, .9);
    }
    &._warning .vue-toast_message {
      background-color:  rgba(#8a6d3b, .9);
    }
    &._error .vue-toast_message {
      background-color:  rgba(#a94442, .9);
    }
  }

  .vue-toast-manager_container {
    &.__top .vue-toast_container {
      top: 0;
    }
    &.__bottom .vue-toast_container {
      bottom: 0;
    }
    &.__left .vue-toast_container {
      left: 0;
    }
    &.__right .vue-toast_container {
      right: 0;
    }
  }

  .vue-toast_message {
    padding: 15px 22px 15px 10px;
    color: white;
    font-family: arial, sans-serif;
  }

  .vue-toast_close-btn {
    cursor: pointer;
    position: absolute;
    right: 5px;
    top: 5px;
    width: 14px;
    height: 14px;
    opacity: .7;
    transition: opacity .15s ease-in-out;
    backface-visibility: hidden;

    &:hover {
      opacity: .9;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 6px;
      width: 14px;
      height: 2px;
      background-color: white;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .vue-toast-enter-active {
    opacity: 0;
    transition: all .2s ease-out;
  }
  .vue-toast-enter-to {
    opacity: 1;
  }
  .vue-toast-leave-active {
    opacity: 1;
    transition: all .1s ease-out;
  }
  .vue-toast-leave-to {
    opacity: 0;
  }
</style>
